import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ActivatedRoute, Router } from '@angular/router';
import { CapitaService } from '../../services/capita.service';
import { AbstractVerifyPaymentComponent } from '../../components/abstract-verify-payment/abstract-verify-payment.component';
import { ApiService } from '../../services/jrni/api.service';
import { DatastoreService } from '../../services/datastore.service';
import { AmazonService } from '../../services/jrni/amazon.service';
import { ServicesService } from '../../services/jrni/services.service';
import { DepartmentService } from '../../services/jrni/department.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-capita-verify-payment',
  templateUrl: './capita-verify-payment.component.html',
  styleUrls: ['./capita-verify-payment.component.scss']
})
export class CapitaVerifyPaymentComponent extends AbstractVerifyPaymentComponent implements OnInit {

  // private purchase: any;
  // private purchases: any = [];
  private bookings: any;

  constructor(
    public apiService: ApiService,
    public spinner: NgxSpinnerService,
    public router: Router,
    public route: ActivatedRoute,
    public datastoreService: DatastoreService,
    public paymentService: CapitaService,
    private servicesService: ServicesService,
    private amazonService: AmazonService,
    private departmentService: DepartmentService,

  ) {
    super(apiService, spinner, router, route, datastoreService, paymentService);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.route.queryParams.subscribe(async params => {
      this.bookingId = params['b'];
      this.paymentId = params['p'];
      this.companyId = params['c'];
      this.pageTitle = 'Verifying payment';
      await this.setup();
    });

  }

  async setup() {
    // get the booking
    const tempDS = JSON.parse(localStorage.getItem("datastore"))
    this.datastoreService.bookingQuestions = tempDS.bookingQuestions
    this.datastoreService.bookings = tempDS.bookings
    this.datastoreService.purchase = tempDS.purchase
    this.datastoreService.selectedSlot = tempDS.selectedSlot
    this.datastoreService.endSlot = tempDS.endSlot
    this.datastoreService.selectedDepartment = tempDS.selectedDepartment
    this.datastoreService.selectedService = tempDS.selectedService
    this.datastoreService.parentDepartment = tempDS.parentDepartment
    this.datastoreService.bookingAnswers = tempDS.bookingAnswers
    this.datastoreService.paidAmount = tempDS.paidAmount
    this.datastoreService.customerDetailsForm = tempDS.customerDetailsForm

    console.log("datastore", this.datastoreService)
    const booking: any = this.datastoreService.bookings[0]
    this.bookings = this.datastoreService.bookings;
    let parentDepartment = await this.departmentService.getParentDepartment();
    this.datastoreService.parentDepartment = parentDepartment;

    const pId = parentDepartment.id;
    const pClient = parentDepartment.self.split('://')[1].split('.')[0];
    const token: any = await this.apiService.getToken(pClient, pId);
    if (token) {
      environment.clientToken = token.token;
    }
    const config = await this.apiService.getConfig(pClient, pId);
    console.log("config", config)
    this.datastoreService.config = config;

    // now get the service
    // const services: any = await this.amazonService.getServices(this.companyId);
    // this.datastoreService.services = services;
    // let parentDepartment = await this.departmentService.getParentDepartment();

    // const service: any = await this.amazonService.getService(this.companyId, booking.service_id);
    // this.servicesService.set(service)
    // const company: any = await this.amazonService.getCompany(this.companyId);
    // const member: any = await this.amazonService.getMemberDetails(this.companyId, booking.client_id);

    // const bookingsData: any = localStorage.getItem('purchaseData');
    // const bookings = JSON.parse(bookingsData);

    // const purchase = await this.amazonService.getPurchase(this.companyId, service.id, this.paymentId);

    // this.datastoreService.checkout = this.purchases[0];
    // this.datastoreService.purchasedBookings = this.bookings;

    await this.verifyPayment(null, booking, null, {}, null);
  }

  async verifyPayment(member: any, booking: any, purchase: any, bookingData: any, company: any) {
    if (!this.paymentPortalId) {
      this.paymentPortalId = localStorage.getItem('paymentPortalId');
    }

    if (this.paymentPortalId) {
      const verify: any = await this.paymentService.query(this.paymentPortalId);
      if (verify['state'] === 'INVALID_REFERENCE') {
        this.spinner.hide();
        return;
      }

      booking.datetime = new Date(booking.datetime);
      booking.end_datetime = new Date(booking.end_datetime);
      if (!verify['ref']) {
        // we do, did we cancel?
        console.log('CANCEL BOOKING HERE');

        await this.cancelBooking();
        alert("payment failed, booking canceled")
        this.router.navigate(['departments']);
        return;
      }

      try {
        if (verify['ref']) {
          if (verify['state'] === 'COMPLETE') {
            this.datastoreService.paidAmount = parseInt(verify['amount']);
            // complete booking
            // this.datastoreService.purchase.price = this.datastoreService.paidAmount
            this.datastoreService.purchase.price = this.datastoreService.paidAmount
            await this.amazonService.updateBooking(this.datastoreService.bookings[0].company_id, this.datastoreService.bookings[0].id, { price: this.datastoreService.paidAmount })
            // paidAmount is Capita's pence (right for the booking price above); /confirm records on JRNI in pounds
            const confirm: any = await this.paymentService.confirm(this.datastoreService.purchase.id, this.datastoreService.bookings[0].company_id, this.datastoreService.paidAmount / 100);

            // send to confirmation page
            this.router.navigate(['confirmation']);
            return;
          }
        }
      }
      catch (err) {
        console.log(err);
      }
    }
    else {
      console.log('NO PAYMENT ID');
      this.router.navigate(['access']);
      return;
    }
  }
  async cancelBooking(): Promise<void> {
    for (const b of this.bookings) {
      await this.amazonService.bookingCancel(this.companyId, b.id, false, "Payment attempted cancelled at payment gateway");
    }
  }

}
